import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { getMyLeavesApi, MyLeave } from "../api/meApi";
import EmployeeShell from "../components/EmployeeShell";
import { COLABORADOR_HOME } from "../routes";
import { useGoBack } from "../../../hooks/useGoBack";

import "./Colaborador.css";

const formatDate = (value?: string | null) =>
  value ? new Date(value).toLocaleDateString("pt-BR", { timeZone: "UTC" }) : "—";

const TYPE_LABELS: Record<string, string> = {
  ATESTADO_MEDICO: "Atestado médico",
  AUXILIO_DOENCA_INSS: "Auxílio-doença (INSS)",
  ACIDENTE_TRABALHO: "Acidente de trabalho",
  LICENCA_MATERNIDADE: "Licença-maternidade",
  LICENCA_PATERNIDADE: "Licença-paternidade",
  SUSPENSAO_DISCIPLINAR: "Suspensão disciplinar",
  LICENCA_NAO_REMUNERADA: "Licença não remunerada",
  SERVICO_MILITAR: "Serviço militar",
  FALTA_JUSTIFICADA: "Falta justificada",
  OUTRO: "Outro",
};

const PAYER_LABELS: Record<MyLeave["payer"], string> = {
  EMPREGADOR: "pago pela empresa",
  INSS: "pago pelo INSS",
  NENHUM: "sem remuneração",
};

/** Afastamentos do próprio colaborador — sem CID nem atestado (ficam com o DP). */
export default function MyLeavesPage() {
  const goBack = useGoBack(COLABORADOR_HOME());
  const [items, setItems] = useState<MyLeave[] | null>(null);

  useEffect(() => {
    getMyLeavesApi()
      .then(setItems)
      .catch((error: any) => {
        toast.error(error?.message || "Não foi possível carregar os seus afastamentos.");
        setItems([]);
      });
  }, []);

  return (
    <EmployeeShell>
      <section className="colabPanel">
        <div className="colabPageTitle">
          <h2 className="colabPanel__title" style={{ margin: 0 }}>
            Meus afastamentos
          </h2>
          <button type="button" className="colabBtn colabBtn--ghost" onClick={goBack}>
            Voltar
          </button>
        </div>

        {items === null ? (
          <p className="colabLoading">Carregando...</p>
        ) : items.length === 0 ? (
          <p className="colabHint">Nenhum afastamento registrado.</p>
        ) : (
          <div className="colabList">
            {items.map((leave) => (
              <article key={leave.id} className="colabListItem">
                <div className="colabListItem__head">
                  <span>{leave.isAutoContinuation ? "Continuação pelo INSS" : TYPE_LABELS[leave.type] ?? leave.type}</span>
                  <span className={`colabBadge ${leave.status === "ATIVO" ? "colabBadge--orange" : "colabBadge--gray"}`}>
                    {leave.status === "ATIVO" ? "Em curso" : "Encerrado"}
                  </span>
                </div>
                <p className="colabListItem__meta">
                  {formatDate(leave.startDate)} a {leave.endDate ? formatDate(leave.endDate) : "sem data de retorno"}
                  {leave.days ? ` · ${leave.days} dia(s)` : ""} · {PAYER_LABELS[leave.payer]}
                </p>
                {leave.expectedEndDate && !leave.endDate ? (
                  <p className="colabListItem__meta">Previsão de retorno: {formatDate(leave.expectedEndDate)}</p>
                ) : null}
              </article>
            ))}
          </div>
        )}

        <p className="colabFooterNote">
          Para cópia do atestado ou dúvidas sobre um afastamento, procure o Departamento Pessoal.
        </p>
      </section>
    </EmployeeShell>
  );
}
